import type { ViewType } from 'owa-calendar-actions';

export function convertScenarioIdToViewType(scenarioId: string): ViewType {
    switch (scenarioId) {
        case 'TimePanelAgenda':
        case 'MonthAgenda':
            return scenarioId;
        default:
            return 'AgendaView';
    }
}
